import MessageBoxComponent from './MessageBox.vue';
import {
    createVNode, render,
} from 'vue';

interface OpenMessageBoxOptions {
    message: string;
    title: string;
    confirmButtonText: string;
    cancelButtonText: string;
    customClass?: string;
}

export function openMessageBox(
    options: OpenMessageBoxOptions
): Promise<boolean | undefined> {
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountInstance = () => {
        document.body.removeChild(div);
    }
    const promise = new Promise<boolean | undefined>((resolve) => {
        const instance = createVNode(MessageBoxComponent, {
            ...(typeof options === 'string' ? { message: options } : options),
            callback: (confirm: boolean) => {
                resolve(confirm);
                unmountInstance();
            },
            cancelCallback: () => {
                resolve(undefined);
                unmountInstance();
            },
        });

        render(instance, div);
    });

    return promise;
}
